import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//------------------------------------------------------------------------------
//                        Отправить комментарий на сервер
//------------------------------------------------------------------------------
export async function toEditComment({ comment, parent_id, image_url }, area){
  const isSignal = (area === 'signal') ? '' : '?type=signal';
  const url = `${backendUrl}/api/comments/update/${ parent_id }/${isSignal}`;

  const bodyData = {
    comment,
  };

  if (image_url !== undefined) {
    bodyData.image_url = image_url;
  }

  const options = {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...bodyData }),
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при изменении комментария: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка изменения комментария: Error fetching get comments list:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
